import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import { invalidateCandidateAvatarQueries } from "./invalidateCandidateAvatarQueries";

interface CandidateWithUuid {
  uuid: string;
}

interface MutateCandidateAvatarFromUrlVariables {
  candidate: CandidateWithUuid;
  url: string;
  source: string;
}

export default function useMutateCandidateAvatarFromUrl() {
  const client = useQueryClient();
  const axios = useAxios();

  return {
    mutation: useMutation({
      mutationFn: ({ candidate, url, source }: MutateCandidateAvatarFromUrlVariables) =>
        axios.post(`/candidate/${candidate.uuid}/avatar-from-url`, {
          url,
          source,
        }),
      onSuccess: (data, variables) => {
        client.setQueryData(
          ["candidateDetails", variables.candidate.uuid],
          data
        );
        return invalidateCandidateAvatarQueries(client);
      },
    }),
  };
}
